/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TablaPresuntivaPrestamoImpresionDetalleModeloMLS } from './tablaPresuntivaPrestamoImpresionDetalleModeloMLS';

export interface ObtenerTablaPresuntivaPrestamoImpresionMS { 
    nombreCliente?: string;
    subClasificacion?: string;
    tipoPrestamo?: string;
    fechaAdjudicacion?: string;
    fechaVencimiento?: string;
    encaje?: string;
    tasaPasivaEncaje?: string;
    tablaPresuntivaPrestamoParaImpresionDetalles?: Array<TablaPresuntivaPrestamoImpresionDetalleModeloMLS>;
    numeroCuotas?: number;
    frecuenciaPago?: number;
    deudaInicial?: number;
    valorEntregar?: number;
    montoSolicitado?: number;
    tasaTotalAnual?: number;
}